import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { RecordingWithSegments } from '../../read';
export class RecordingsForOrder {
    /**
     * Recordings that match the order details.
     * @param recordings The recordings.
     * @param hasAudio Whether the order has audio once on-the-record timeframes and sealed segments are factored in.
     * @param requestingUserHasAccessToAllRecordings Whether the requesting user can access all the matched recordings.
     * @param requestingUserCanAccessSealedContent Whether the requesting user can access the recordings' sealed content.
     */
    constructor(recordings, hasAudio, requestingUserHasAccessToAllRecordings, requestingUserCanAccessSealedContent) {
        this.hasAudio = hasAudio;
        this.requestingUserHasAccessToAllRecordings = requestingUserHasAccessToAllRecordings;
        this.requestingUserCanAccessSealedContent = requestingUserCanAccessSealedContent;
        this.recordings = recordings;
    }
}
__decorate([
    Type(() => RecordingWithSegments),
    __metadata("design:type", Array)
], RecordingsForOrder.prototype, "recordings", void 0);
